<template>
  <div>
    <router-view :key="key"></router-view>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  mounted () {
  },
  computed: {
    key () {
      return this.$route.path
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>

</style>
